import React from "react";
import { connect } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { unstableFeaturesStatus } from "./selectors/unstable-features";
import { UnstableFeaturesStatusContext } from "./ui/components/hoc/ifUnstableFeatureEnabled";
import { QaUnstableFeaturesStatusModal } from "./ui/components/QaUnstableFeaturesStatusModal";

export const Router = connect(
  (state, ownProps) => ({
    unstableFeaturesStatus: unstableFeaturesStatus(state),
  }),
  (dispatch, ownProps) => ({}),
)(({ unstableFeaturesStatus, history, Routes }) => {
  if (unstableFeaturesStatus.retrieved !== true) {
    // Do not even try to display anything while unstable features have not been retrieved!
    return null;
  }
  return (
    <UnstableFeaturesStatusContext.Provider value={unstableFeaturesStatus}>
      <QaUnstableFeaturesStatusModal />
      <ConnectedRouter history={history}>
        <Routes />
      </ConnectedRouter>
    </UnstableFeaturesStatusContext.Provider>
  );
});



// WEBPACK FOOTER //
// ./src/sc/Router.js